import React, { Component } from "react";
import { Link } from 'react-router-dom';
import { connect } from "react-redux";
import ReactTelInput from 'react-telephone-input';
import 'react-telephone-input/lib/withStyles';
import flags from '../../images/flags.png'
import imageVk from '../../images/vk-social.svg';
import imageGoogle from '../../images/gl-logo2.png';
import FacebookLogin from 'react-facebook-login';
// import GoogleLogin from 'react-google-login';

import {
    createUser2,
    createUserVerification,
    clearErrorsCreateUser,
    phoneConfirmation,
    loginUser,
    loginFBUser,
    getCurrentUser
} from '../../actions/session';
import {preferredCountries, errorMessagesObject, getClientSecret, getClientId} from '../Commons/Constants';

class Individual extends Component {
    constructor(props) {
        super(props);

        this.state = {
            fieldErrors: {},
            errorMessageConfirmPassword: false,
            errorShowMessageConfirmPassword: false,

            codeSended: false,
            codeReSended: false,
            smsTime: 300,

            phone: '',
            selectedCountry: '',
            
            agreement: false,
            registerStatus: false,
        }
    }

    componentWillMount() {
        const { hash, search } = this.props.location;

        const hash_params = new URLSearchParams(hash);
        const access_token_vk = hash_params.get('#access_token');
        localStorage.setItem('access_token', access_token_vk);

        window.history.pushState(null, null, "/signup");

        if(access_token_vk){
            this.socialLogin('vk-oauth2', access_token_vk, () => {
            });
        }
    }

    componentWillUnmount() {
        this.props.clearErrorsCreateUser();
    }

    handleReSendCode(e) {
        e.preventDefault();
        e.stopPropagation();

        const { phoneConfirmation } = this.props;
        const username = this.refs.username.value;
        let {phone, selectedCountry, agreement, errorMessageConfirmPassword} = this.state;

        this.showError();
        if (errorMessageConfirmPassword || !agreement) return false;

        let isValid = (phone.length !== selectedCountry.format.length) ? false : true;

        this.setState({
            fieldErrors: {
                ...this.state.fieldErrors,
                phone: (isValid) ? false : true
            }
        })

        if(!isValid) return false;

        clearInterval(this.intervalTick);

        phoneConfirmation({phone: encodeURIComponent(phone), email: username}, () => {
            this.setState(
                {codeSended: true, reSendCode: true, smsTime: 300},
                () => this.intervalTick = setInterval(() => this.tick(), 1000)
            );
        });
    }

    tick() {
        if(this.state.smsTime < 1) {
            this.setState({smsTime: 0}, () => clearInterval(this.intervalTick));
            return;
        }
        this.setState({smsTime: this.state.smsTime - 1});
    }

    // Если пароли несопадают то идет присваивания состояния errorMessageConfirmPassword
    VerificationConfirmPassword() {
        if (this.refs.password.value === this.refs.confirmPassword.value) {
            this.setState({
                errorMessageConfirmPassword: false
            });
        } else {
            this.setState({
                errorMessageConfirmPassword: true
            });
        }
    }

    // Показывает на странице сообщение об ошибке если пароли несовпадает
    showError() {
        if (this.state.errorMessageConfirmPassword === true) {
            this.setState({
                errorShowMessageConfirmPassword: true
            });
        }
    }

    // Регестрирует пользователя в системе
    handleSubmitSignUp(e) {
        e.preventDefault();

        const { createUser2, loginUser, getCurrentUser, history } = this.props;
        let {phone, selectedCountry, agreement, errorMessageConfirmPassword} = this.state;

        this.showError();
        if (errorMessageConfirmPassword || !agreement) return false;

        let isValid = (phone.length !== selectedCountry.format.length) ? false : true;

        this.setState({
            fieldErrors: {
                ...this.state.fieldErrors,
                phone: (isValid) ? false : true
            }
        })

        if(!isValid) return false;
        
        const formData = new FormData();

        for (const key in this.refs){
            const val = this.refs[key].value
            if (val === undefined) continue;
            else if (key === "confirmPassword") continue;
            formData.append(key, val)
        }

        formData.append('phone', phone);
        formData.append('is_suggest', agreement);

        createUser2(formData, () => {
            //this.setState({registerStatus: true})
            loginUser({
                    username: this.refs.username.value,
                    password: this.refs.password.value
                },
                () => history.push("/", "home"),
                (token) => getCurrentUser(token)
            )
        });
    }

    // Вызывает метод которые отсылает полученый СМС-код на сервер
    handleSubmitCode(e) {
        e.preventDefault();

        const { phoneConfirmation } = this.props;
        const username = this.refs.username.value;
        let {phone, selectedCountry, agreement, errorMessageConfirmPassword} = this.state;

        this.showError();
        if (errorMessageConfirmPassword || !agreement) return false;
        
        let isValid = (phone.length !== selectedCountry.format.length) ? false : true;

        this.setState({
            fieldErrors: {
                ...this.state.fieldErrors,
                phone: (isValid) ? false : true
            }
        })

        if(!isValid) return false;

        phoneConfirmation({phone: encodeURIComponent(phone), email: username}, () => {
            this.setState(
                {codeSended: true},
                () => this.intervalTick = setInterval(() => this.tick(), 1000)
            );
        });
    }

    handlePhoneChange(phone, country) {
        const initCountry = Object.assign({}, this.state.selectedCountry);

        let code = "+" + country.dialCode;
        let myCode = phone.substr(0, code.length);

        let isValid = (initCountry.format && (myCode !== code || phone.length > country.format.length)) ? false : true;

        this.setState({
            phone,
            selectedCountry: country,
            fieldErrors: {
                ...this.state.fieldErrors,
                phone: isValid ? false : true
            }
        });
    }

    handlePhoneBlur(phone, country) {
        let code = "+" + country.dialCode;
        let myCode = phone.substr(0, code.length);

        let isValid = (myCode !== code || phone.length !== country.format.length) ? false : true;

        this.setState({
            phone,
            selectedCountry: country,
            fieldErrors: {
                ...this.state.fieldErrors,
                isValid: isValid ? true : false,
                phone: isValid ? false : true
            }
        });
    }

    handleVK() {
        let URL = "https://oauth.vk.com/authorize?client_id=6375392&display=page&redirect_uri=http://fixfact.ru/signup&scope=photos,group,offline,wall,notify,email&response_type=token&v=5.74";

        window.location.replace(URL);
    }

    responseFacebook(response) {
        if (response) {
            this.socialLogin('facebook', response.accessToken);
        }
    }

    responseGoogle(response) {
        if (response.accessToken) {
            this.socialLogin('google-oauth2', response.accessToken);
        }
    }

    socialLogin(type, token, callback) {
        const { history } = this.props;
        let formData = new FormData();
        formData.append('grant_type', 'convert_token');
        formData.append('client_id', getClientId(type));
        formData.append('client_secret', getClientSecret(type));
        formData.append('backend', type);
        formData.append('token', token);

        if(callback) callback();

        this.props.loginFBUser(
            formData,
            () => history.push("/", "home"),
            (token) => this.props.getCurrentUser(token)
        )
    }

    render() {
        const { register } = this.props;
        const { errorMessage, isFetching } = register;

        return (
            <div className="menu-content-individual menu-content-item tab-parent screen-bottom-block">
                <div className="rounded-white-block">
                    
                    <div className="white-block-content">
                        <div className="sign-up-form-wrap">
                            <form onSubmit={(event) => { this.state.codeSended ? this.handleSubmitSignUp(event) : this.handleSubmitCode(event) }}>

                                <input type="text" placeholder="Фамилия" className="width100" required ref="last_name" />

                                <input type="text" placeholder="Имя" className="width100" required ref="first_name" />

                                <input type="text" placeholder="Отчество" className="width100" required ref="patronymic_name" />

                                <input type="email" placeholder="Электронная почта" className="width100" required ref="username" />
                                {
                                    errorMessage && errorMessage.username_errors
                                    ? errorMessage.username_errors.map((text, index) =>
                                        <span key={index} className="input-error-text">{text}</span>
                                    )
                                    : ''
                                }

                                <input type="password" placeholder="Пароль" className="width100" required onChange={() => { this.VerificationConfirmPassword() }} ref="password" />

                                <input type="password" placeholder="Подтвердите пароль" className="width100" required onChange={() => { this.VerificationConfirmPassword() }} ref="confirmPassword" />
                                {
                                    this.state.errorShowMessageConfirmPassword && this.state.errorMessageConfirmPassword
                                        ?
                                        (<span className="input-error-text">Пароли несовпадают</span>) : ''
                                }

                                <div className="input-wrap width100">
                                    <ReactTelInput
                                        preferredCountries={preferredCountries}
                                        defaultCountry="ru"
                                        flagsImagePath={flags}
                                        onChange={(val, val2) => this.handlePhoneChange(val, val2)}
                                        onBlur={(val, val2) => this.handlePhoneBlur(val, val2)}
                                        />
                                </div>
                                {
                                    errorMessage && errorMessage.phone
                                    ? errorMessage.phone.map((text, index) =>
                                        <span key={index} className="input-error-text">{text}</span>
                                    )
                                    : null
                                }
                                {
                                    this.state.fieldErrors && this.state.fieldErrors.phone
                                    ? <span className="input-error-text">{errorMessagesObject.phone}</span>
                                    : null
                                }
                                

                                {
                                    this.state.codeSended || this.state.codeReSended ?
                                    <div style={{marginTop: '15px'}}>
                                        {
                                            this.state.smsTime < 1 ?
                                            <button onClick={(e) => this.handleReSendCode(e)} style={{border:0,backgroundColor:'transparent',textDecoration:'underline',padding:0}}>Отправить заново</button>
                                            :
                                            <div>
                                                <div className="input-success-text">Вам отпрален СМС-код, введите чтобы завершить регистрацию.</div>
                                                <div className="input-info-text">СМС-код активен в течении {this.state.smsTime} сек.</div>
                                            </div>
                                        }
                                    </div>
                                    : null
                                }

                                {
                                    this.state.codeSended ?
                                    <div>
                                        <input type="text" className="width100" placeholder="СМС-код" required ref="phone_confirmation_key" />
                                        {
                                            errorMessage && errorMessage.phone_confirmation_key
                                            ? errorMessage.phone_confirmation_key.map((text, index) =>
                                                <span key={index} className="input-error-text">{text}</span>
                                            )
                                            : null
                                        }
                                    </div>
                                    : null
                                }

                                <div className="checkboxes checkboxes_align-left" style={{marginTop: '25px'}}>
                                    <label className="c-form__label" htmlFor="agreement">
                                        <label className="custom-radio">
                                            <input
                                                defaultChecked={this.state.agreement}
                                                className="value"
                                                type="checkbox"
                                                id="agreement"
                                                onChange={() => this.setState({agreement: !this.state.agreement})}
                                                />
                                            <div></div>
                                        </label>
                                        <span className="text">Я согласен с <Link to="/information/Pravila">правилами использования</Link></span>
                                    </label>
                                </div>
                            
                                <div className="big-button button-action width100">
                                    {
                                        this.state.agreement ?
                                            this.state.codeSended
                                            ? <button className={isFetching ? 'disabled' : ''}>Зарегистрироваться</button>
                                            : <button className={isFetching ? 'disabled' : ''}>Выслать код</button>
                                        : 
                                        <button className='disabled' disabled>{this.state.codeSended ? 'Зарегистрироваться' : 'Выслать код'}</button>
                                    }
                                </div>
                            </form>

                            <div style={{ marginTop: '25px', alignItems: 'center', justifyContent: 'space-between', display: 'flex' }}>
                                <div style={{ display: 'flex' }}>
                                    <FacebookLogin
                                        appId="202889673626661"
                                        autoLoad={false}
                                        isDisabled={isFetching ? true : false}
                                        fields={['email']}
                                        scope={['email']}
                                        callback={(response) => this.responseFacebook(response)}
                                        textButton=''
                                        cssClass="test-fb-button"
                                        icon="fa-facebook"
                                    />
                                    {/* <GoogleLogin
                                        clientId={`491145896490-t5i7j0sd5f31pacm0k9sehlljb0o5vq7.apps.googleusercontent.com`}
                                        buttonText=''
                                        autoLoad={false}
                                        disabled={isFetching ? true : false}
                                        redirectUri='https://fixfact.ru'
                                        style={{width: '30px', height: '30px', border: 'none', padding: 0, marginRight: '10px', backgroundColor: 'transparent'}}
                                        onSuccess={response => this.responseGoogle(response)}
                                        onFailure={response => this.responseGoogle(response)}
                                    >
                                        <img
                                            src={imageGoogle}
                                            style={{ width: '30px', cursor: 'pointer' }}
                                            alt="vk icon"
                                        />
                                    </GoogleLogin> */}
                                    <a>
                                        <img
                                            src={imageVk}
                                            style={{ width: '30px', marginRight: '5px', cursor: 'pointer' }}
                                            alt="vk icon"
                                            onClick={() => isFetching ? false : this.handleVK()}
                                        />
                                    </a>

                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state
    };
};
export default connect(
    mapStateToProps,
    {
        createUser2,
        createUserVerification,
        clearErrorsCreateUser,
        phoneConfirmation,
        loginUser,
        loginFBUser,
        getCurrentUser
})(Individual);


// WEBPACK FOOTER //
// ./src/components/SignUp/Individual.js